import * as moment from "moment";

export class VinoItem {
    abilitato_sconto_carrello: boolean;
    annate: any;
    associata_item: any;
    associate: boolean;
    associate_sconto: any;
    cancellato: string;
    colore_id: string;
    colore: string;
    cantinalink: string;
    codiceForm: string;
    descrizione: string;
    disponibile: boolean;
    finePromo: string;
    id: number;
    idcantina: number;
    idregione: number;
    imgsrc: string;
    inSconto: boolean;
    inizioPromo: string;
    isBestsellers: boolean;
    isEvidenza: boolean;
    modrewrite: string;
    nome: string;
    nomecantina: string;
    ordine: number;
    prezzo: number;
    prezzoScontato: number;
    prezzoScontatoWineClub: number;
    qtaMinima: number;
    qta: number;
    recensioni:
        { totrecensioni: number, media: number };
    regione: string;
    scontato: boolean;
    scontoEsclusivo: boolean;
    tags: Array<any>;
    specifiche: {
        abbinamento?: any;
        annata?: any;
        consumo?: any;
        formato?: any;
        gradazione?: any;
        gusto?: any;
        olfatto?: any;
        servizio?: any;
        tipologia?: any;
        vitigno?: any;
    };
    specificheList: any;
    winecoins: number;
    pdfVino: string;

    constructor(vino) {
        this.abilitato_sconto_carrello = vino.abilitato_sconto_carrello === '1' ? true : false;
        this.annate = vino.annate;
        this.associata_item = vino.associata_item;
        this.associate = vino.associate;
        this.associate_sconto = vino.associate_sconto;
        this.cancellato = vino.cancellato;
        this.cantinalink = vino.cantinalink;
        this.codiceForm = vino.codiceForm;
        this.colore_id = vino.colore_id;
        this.colore = vino.colore;
        this.descrizione = vino.descrizione;
        this.disponibile = vino.disponibile === '1' ? true : false;
        this.finePromo = vino.finePromo;
        this.id = vino.id;
        this.idcantina = vino.idcantina;
        this.idregione = vino.idregione;
        this.imgsrc = vino.imgsrc;
        this.inSconto = vino.inSconto === '1' ? true : false;
        this.inizioPromo = vino.inizioPromo;
        this.isBestsellers = vino.isBestsellers === '1' ? true : false;
        this.isEvidenza = vino.isEvidenza === '1' ? true : false;
        this.modrewrite = vino.modrewrite;
        this.nome = vino.nome;
        this.nomecantina = vino.nomecantina;
        this.ordine = vino.ordine;
        this.prezzo = parseFloat(vino.prezzo);
        this.prezzoScontato = parseFloat(vino.prezzoScontato);
        this.prezzoScontatoWineClub = parseFloat(vino.prezzoScontatoWineClub);
        this.qta = vino.qta ? parseInt(vino.qta, 10) : 1;
        this.qtaMinima = parseInt(vino.qtaMinima, 10);
        this.recensioni = vino.recensioni;
        this.recensioni.media = parseFloat(vino.recensioni.media);
        this.recensioni.totrecensioni = parseInt(vino.recensioni.totrecensioni, 10);
        this.regione = vino.regione;
        this.scontato = vino.scontato === '1' ? true : false;
        this.scontoEsclusivo = vino.scontoEsclusivo === '1' ? true : false;
        this.tags = vino.tags;
        this.specifiche = vino.specifiche;
        this.specificheList = null;
        this.winecoins = vino.winecoins;
        this.pdfVino = vino.pdfVino;
    }

    public hasSconto(vino): boolean {
        return vino.inSconto;
    }

    public choosePrezzoScontato(vino): number {
        if (this.hasSconto(vino)) {
            if (vino.scontoEsclusivo) {
                return vino.prezzoScontatoWineClub;
            } else {
                return vino.prezzoScontato;
            }
        } else {
            return vino.prezzo;
        }
    }

    public getSpecifiche(vino) {
        return vino.specifiche ?
            [
                { img: '../../../assets/img/wineclub/colore.png', title: TRANSLATE('base.specifiche.colore'), data: this.getColoreTradotto(vino.colore_id), traduci: true },
                { img: '../../../assets/img/wineclub/gradazione.png', title: TRANSLATE('base.specifiche.gradazione'), data: vino.specifiche.gradazione, traduci: false },
                { img: '../../../assets/img/wineclub/annata.png', title: TRANSLATE('base.specifiche.annata'), data: vino.specifiche.annata, traduci: false },
                { img: '../../../assets/img/wineclub/formato.png', title: TRANSLATE('base.specifiche.formato'), data: vino.specifiche.formato, traduci: false },
                { img: '../../../assets/img/wineclub/consumo.png', title: TRANSLATE('base.specifiche.consumo'), data: vino.specifiche.consumo, traduci: false },
                { img: '../../../assets/img/wineclub/servizio.png', title: TRANSLATE('base.specifiche.servizio'), data: vino.specifiche.servizio, traduci: false },
                { img: '../../../assets/img/wineclub/vitigno.png', title: TRANSLATE('base.specifiche.vitigno'), data: vino.specifiche.vitigno, traduci: false },
                { img: '../../../assets/img/wineclub/profumo.png', title: TRANSLATE('base.specifiche.profumo'), data: vino.specifiche.olfatto, traduci: false },
                { img: '../../../assets/img/wineclub/gusto.png', title: TRANSLATE('base.specifiche.gusto'), data: vino.specifiche.gusto, traduci: false },
                { img: '../../../assets/img/wineclub/abbinamento.png', title: TRANSLATE('base.specifiche.abbinamento'), data: vino.specifiche.abbinamento, traduci: false },
            ] :
            []
    }

    public getColoreTradotto(colore_id: string): string {
        const colori = [
            { id: '0', colore: null },
            { id: '1', colore: TRANSLATE('base.rosso') },
            { id: '2', colore: TRANSLATE('base.bianco') },
            { id: '3', colore: TRANSLATE('base.rosato') },
            { id: '4', colore: TRANSLATE('base.spumante') },
            { id: '5', colore: TRANSLATE('base.altriprodotti') },
        ];

        const colore = colori.find(c => c.id === colore_id)?.colore;

        if (!colore) {
            return null;
        }
        return colore ? colore : '';
    }

    public durataPromo(vino) {
        const durata = moment(vino.finePromo).diff(moment(), 'days');
        return durata != 0 ? durata : 1;
    }

    public percentualeSconto(vino) {
        const first = parseFloat(vino.prezzo);
        const last = vino.choosePrezzoScontato(vino);
        return last * 100 / first - 100;
    }
}


function TRANSLATE(str: string) {
    return str;
}